import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo } from "react";

import colors from "app/colors";
import { DownloadIcon } from "modules/icons";
import { FileFragment, FileGalleryFragment } from "gql/graphql";
import useDownloadFile from "modules/hooks/use-download-file";

interface IProps {
  file: FileGalleryFragment | FileFragment;
}

const MessagePopoverDownloadFileButton: React.FC<IProps> = ({ file }) => {
  const { downloadFile } = useDownloadFile(file);

  return (
    <Button variant="link" onClick={downloadFile}>
      <HStack spacing={3}>
        <DownloadIcon boxSize={5} fill={colors.blue} />
        <Text fontSize={14} color={colors.blackSecondary}>
          Download
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessagePopoverDownloadFileButton);
